import { useFlags } from '@flagsmith/flagsmith/react'
import type { AnySchema } from 'yup'
import { type FeatureFlags, FeatureFlagsSchema } from './flags'

export function parseFlag<T>(value: unknown, schema: AnySchema): T {
  let parsedValue = value

  if (typeof value === 'string') {
    try {
      parsedValue = JSON.parse(value)
    } catch {
      parsedValue = value
    }
  }

  return schema.validateSync(parsedValue) as T
}

export function useFeatureFlag<T extends keyof FeatureFlags>(
  flagName: T
): FeatureFlags[T] | null {
  const flags = useFlags([flagName])
  const flag = flags[flagName]
  const schema = FeatureFlagsSchema[flagName]

  const rawValue =
    schema.type === 'boolean'
      ? flag?.enabled
      : flag?.enabled
        ? flag?.value
        : null

  if (!rawValue) return null

  return parseFlag<FeatureFlags[T]>(rawValue, schema)
}
